import {createStyles, makeStyles, Theme, Typography} from '@material-ui/core';
import clsx from 'clsx';
import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {energyConsumptionSlice} from '../../../state/features/energy-consumption/energy-consumption-slice';
import {FixedPeriodCategory} from '../../../state/features/energy-consumption/types';
import {AppState} from '../../../state/store';
import {basicCardBgColor, primaryColor} from '../../../styles/color-constants';
import {h6} from '../../../styles/font-size-constants';
import {BasicCard} from '../../../view/components/default-components/basic-card/basic-card';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sortFlexbox: {
      cursor: 'pointer',
      marginLeft: 5,
      marginRight: 5,
      minWidth:40,
      maxHeight: 40,
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#3333',
        color: '#FFF',
      },
    },
    selected: {
      backgroundColor: primaryColor,
      color: basicCardBgColor,
      '&:hover': {
        backgroundColor: primaryColor,
        color: basicCardBgColor,
      },
    },
    typogrphy: {
      fontSize: h6,
    },
  }),
);

interface PropsFromParent {
  periodCategory: FixedPeriodCategory;
  btnText: string;
}

export const ConsumptionFixedDaysButton: FC<PropsFromParent> = React.memo(({children, ...props}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {currentFixedPeriodCategory} = useSelector((store: AppState) => store.energyConsumptionReducer);
  const handleFixedDatePressed = () => {
    dispatch(energyConsumptionSlice.actions.setPeriodCategory(props.periodCategory));
  };

  return (
    <BasicCard
      className={clsx(currentFixedPeriodCategory === props.periodCategory ? classes.selected : null, classes.sortFlexbox)}
      onClick={handleFixedDatePressed}>
      <Typography className={classes.typogrphy}>{props.btnText}</Typography>
    </BasicCard>
  );
});
